export class Atividade {
  codigoPolo?: number;
  dataInicial?: Date;
  dataFinal?: Date;
  dataDeCriacao?: Date;
  token?: string;
  fileName?: string;
  status?: number;
  codigoPerfil?: number;
  nomePerfil?: string;
}
